export default {
  options: {
    true: 'Ja',
    false: 'Nein',
  },
};
